import * as React from "react";
import { useTranslation } from "react-i18next";
import { type SelectTriggerProps } from "@radix-ui/react-select";
import { changeLanguage } from "i18next";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { cn, SUPPORTED_LANGUAGES } from "@/lib/utils";

export function LanguageSwitcher({ className, ...props }: SelectTriggerProps) {
  const { t } = useTranslation();
  const [language, setLanguage] = React.useState<(typeof SUPPORTED_LANGUAGES)[number]>(
    (localStorage.getItem("language") as (typeof SUPPORTED_LANGUAGES)[number]) || "nl",
  );

  return (
    <Select
      value={language}
      onValueChange={(v) => {
        if (v === "en" || v === "nl") {
          localStorage.setItem("language", v);
          setLanguage(v);
          changeLanguage(v);
        }
      }}
    >
      <SelectTrigger className={cn("h-7 w-32 text-xs [&_svg]:h-4 [&_svg]:w-4", className)} {...props}>
        <span className="text-muted-foreground">{language === "en" ? "Language:" : "Taal:"}</span>
        <SelectValue placeholder={t("Select Language")} />
      </SelectTrigger>
      <SelectContent>
        {SUPPORTED_LANGUAGES.map((language) => (
          <SelectItem key={language} value={language} className="text-xs">
            {language === "en" ? "English" : "Dutch"}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
